module.exports = __webpack_public_path__ + "img/empty_state_my_skills.b13c0974.svg";